function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Social",
  transform: "translate(-172.263 -1.256)"
}, React.createElement("path", {
  id: "Path_316",
  "data-name": "Path 316",
  d: "M18.234,1H1.216A1.215,1.215,0,0,0,0,2.216V16.8a1.215,1.215,0,0,0,1.216,1.216H18.234A1.215,1.215,0,0,0,19.45,16.8V2.216A1.215,1.215,0,0,0,18.234,1ZM17.019,15.587H2.431V7.957L9.122,11.78a1.213,1.213,0,0,0,1.206,0l6.691-3.823Zm0-10.43L9.725,9.326,2.431,5.157V3.431H17.019Z",
  transform: "translate(172.263 0.256)",
  fill: "#cecfd0"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19.45,
    height: 17.019,
    viewBox: "0 0 19.45 17.019"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/mail.795575ed.svg";
export { SvgComponent as ReactComponent };